
import { Button } from '@/components/ui/button';
import { OnboardingData } from '../OnboardingFlow';

interface WelcomeStepProps {
  data: OnboardingData;
  onComplete: () => void;
  onBack: () => void;
}

const WelcomeStep = ({ data, onComplete, onBack }: WelcomeStepProps) => {
  return (
    <div className="text-center space-y-8">
      <div className="space-y-6">
        <div className="w-20 h-20 bg-gradient-to-br from-green-success to-green-success rounded-full flex items-center justify-center mx-auto shadow-lg">
          <span className="text-white font-bold text-2xl">✓</span>
        </div>
        
        <h1 className="text-3xl font-bold text-slate-dark font-sans">
          Welcome to Show Up!
        </h1>
        
        <div className="space-y-3">
          <p className="text-lg text-slate-medium font-sans">
            You're ready to create your first Pact.
          </p>
          <p className="text-base text-slate-light font-sans">
            Remember: Show up again tomorrow.
          </p>
        </div>
        
        {data.firstName && (
          <p className="text-lg text-blue-primary font-medium font-sans">
            Welcome, {data.firstName}! 🎉
          </p>
        )}
      </div>
      
      <div className="space-y-3">
        <Button
          onClick={onComplete}
          className="w-full h-14 text-lg font-semibold bg-blue-primary hover:bg-blue-light text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
        >
          Create My First Pact
        </Button>
        
        <Button
          onClick={onBack}
          variant="ghost"
          className="w-full h-12 text-slate-medium hover:text-slate-dark hover:bg-slate-whisper rounded-xl transition-all duration-300 font-sans"
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default WelcomeStep;
